/***
 * Created on 2023/8/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useState} from 'react';
import TrustDeviceRow from "./trust_device_row";
import LoginDeviceTableRow from "../../login_device/login_device_table_row";
import Table from "../../../common/table/table";
import {useTranslation} from "react-i18next";

function TrustDeviceList({data}) {
    const { t } = useTranslation();
    const [currentSortType, setCurrentSortType] = useState(t('@Location (Approximate)@'));
    const [sortDirection, setSortDirection] = useState('desc');

    const trustDeviceTableFields = [
        {
            id: 1,
            name: t('@Device@'),
            size: 25,
            sortable: true
        },
        {
            id: 2,
            name: t('@Name@'),
            size: 21,
            sortable: true
        },
        {
            id: 3,
            name: t('@Domain@'),
            size: 15,
            sortable: true
        },
        {
            id: 4,
            name: t('@Location (Approximate)@'),
            size: 24,
            sortable: true
        },
        {
            id: 5,
            name: t('@Account access@'),
            size: 15,
            sortable: false,
            isAction: true
        }

    ];

    return (
        <div className="comp-content-wrapper">

            <Table fieldNameList={trustDeviceTableFields} currentSortType={currentSortType} setCurrentSortType={setCurrentSortType} sortDirection={sortDirection} setSortDirection={setSortDirection}>
            {
                data && data.sort((a,b)=>{
                    if (currentSortType === t('@Location (Approximate)@')) {
                        return sortDirection === 'desc' ? new Date(b.added_on) - new Date(a.added_on) : new Date(a.added_on) - new Date(b.added_on);
                    }
                    else if (currentSortType === t('@Device@')) {
                        return sortDirection === 'desc' ? b?.display_device_name?.localeCompare(a?.display_device_name) : a?.display_device_name?.localeCompare(b?.display_device_name);
                    }
                    else if (currentSortType === t('@Name@')) {
                        return sortDirection === 'desc' ? b?.name?.localeCompare(a?.name) : a?.name?.localeCompare(b?.name);
                    }
                    else if (currentSortType === t('@App name@')) {
                        return sortDirection === 'desc' ? b?.app?.display_name?.localeCompare(a?.app?.display_name) : a?.app?.display_name?.localeCompare(b?.app?.display_name);
                    }
                    else if (currentSortType === t('@Domain@')) {
                        return sortDirection === 'desc' ? b?.display_domain?.localeCompare(a?.display_domain) : a?.display_domain?.localeCompare(b?.display_domain);
                    }
                }).map(row => <TrustDeviceRow item={row} fieldList={trustDeviceTableFields} key={row._id} />)
            }
            </Table>

        </div>
    );
}

export default TrustDeviceList;